import React, { useState, useEffect } from 'react';
import { DeliveryService } from '../Services/DeliveryService';
import { makeStyles } from '@material-ui/core/styles';
import { Table, TableHead, TableRow, TableCell, Typography, Grid, Paper, TableBody, Fade, CircularProgress } from '@material-ui/core';
import EnhancedTableToolbar from '../components/EnhancedTableToolbar';
import XLSX from 'xlsx';
import moment from 'moment';
import { format_fancy_notime } from '../Utils';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3),
        overflow: 'auto'
    }
  })
);

function StoresWithNoRecentOrders(props) {
    const classes = useStyles();
    const [fetch, setFetch] = useState(false);
    const [stores, setStores] = useState([]);
    const [rows, setRows] = useState([]);
    const days = 7;

    useEffect(() => {
        props.setTitle(`Stores with no recent order in last ${days} days (${stores.length})`);
    }, [stores]);

    useEffect(() => {
        setFetch(true);
        props.isLoading(true);
        DeliveryService.getStoresWithNoRecentOrders(days)
        .then((data) => {
            console.log(data.report);
            setStores(data.report);
            let rows = [];
            data.report.forEach((element, index) => {
                rows.push(
                <TableRow key={index}>
                    <TableCell>
                        <Typography variant="subtitle1" color="textPrimary">{index + 1}</Typography>
                    </TableCell>
                    <TableCell>
                        <Typography variant="subtitle1" color="textPrimary">{element.store_name}</Typography>
                    </TableCell>
                    <TableCell align="right">
                        <Typography variant="subtitle1" color="textPrimary">{element.name}</Typography>
                    </TableCell>
                    <TableCell align="right">
                        <Typography variant="subtitle1" color="textPrimary">{element.mobile_no}</Typography>
                    </TableCell>
                    <TableCell>
                        <Typography variant="subtitle1" color="textPrimary">{element.last_schedule_date ? moment(element.last_schedule_date).format(format_fancy_notime): "-"}</Typography>
                    </TableCell>
                </TableRow>)
            });
            setRows(rows);
            setFetch(false);
            props.isLoading(false);
        })
        .catch((error) => {
            setFetch(false);
            props.isLoading(false);
        })
    }, []);

    function exportReport() {
        if(stores && stores.length > 0){
            let sheetname = 'Stores';
            let exportData = [];
            exportData = [["Sl No", "Store", "Manager", "Mobile", "Added on"]];
            stores.forEach((row, index) => {
                    exportData.push([index+1, row.store_name, row.name, row.mobile_no, (row.last_schedule_date ? moment(row.last_schedule_date).format(format_fancy_notime): "-")]);
            });

            if(exportData){
                const wb = XLSX.utils.book_new();
                const wsAll = XLSX.utils.aoa_to_sheet(exportData);
                XLSX.utils.book_append_sheet(wb, wsAll, sheetname );
                XLSX.writeFile(wb, sheetname + ".xlsx");
            }
        } else {
            this.props.showSnackBar('Nothing to export', 'error');
        }
    }

    return (
        <div className="Home">
				<div className="">
				<Grid container spacing={2} style={{marginTop: 20}}>
                    <Grid item lg={12} xs={12}>
                        <Paper className={classes.root}>
                            <EnhancedTableToolbar title="" exportReport={exportReport}/>
                            <Table size="small" >
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="subtitle2" style={{fontSize: 18}} color="textPrimary">Store</Typography>
                                        </TableCell>
                                        <TableCell align="right">
                                            <Typography variant="subtitle2" style={{fontSize: 18}} color="textPrimary">Manager</Typography>
                                        </TableCell>
                                        <TableCell align="right">
                                            <Typography variant="subtitle2" style={{fontSize: 18}} color="textPrimary">Mobile</Typography>
                                        </TableCell>
                                        <TableCell style={{width: 130}}>
                                            <Typography variant="subtitle2" style={{fontSize: 18}} color="textPrimary">Last Schedule</Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows}
                                </TableBody>
                            </Table>
                            <Fade
                                in={fetch}
                                style={{
                                    transitionDelay: fetch ? '10ms' : '0ms'
                                }}
                                unmountOnExit
                                >
                                <CircularProgress style={{marginTop: 20}}/>
                            </Fade>
                        </Paper>
                    </Grid>
				</Grid>
            </div>
        </div>
      );
};

export default StoresWithNoRecentOrders;